"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabControl = void 0;
var TabControl_1 = require("./TabControl");
Object.defineProperty(exports, "TabControl", { enumerable: true, get: function () { return TabControl_1.TabControl; } });
//# sourceMappingURL=index.js.map